import { useMutation } from "react-query";
import { addWarrantyCoverage } from "../../../../../actions/Utilities/WarrantyCoverage";
import { toast } from "components/toastNotification";
import { IWarrantyCoverage } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateWarrantyCoverage,
  warrantyCoverageReFetching,
} from "../atoms/atoms";

const useAddWarrantyCoverage = () => {
  const setIsAddState = useSetRecoilState(addStateWarrantyCoverage);
  const [isReFetching, setIsReFetching] = useRecoilState(
    warrantyCoverageReFetching
  );

  const { mutate } = useMutation(
    (NewData: IWarrantyCoverage) => addWarrantyCoverage(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Warranty Coverage failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Warranty Coverage Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Warranty Coverage Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Warranty Coverage failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Warranty Coverage failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Warranty Coverage failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Warranty Coverage failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddWarrantyCoverage;
